import { InvoicePlusIcon } from './InvoicePlusIcon';

/**
 * author: Jeff Anders
 * id 8AEAA39A-29A9-4627-A0D0-49DD64922B55
 * name invoice-plus
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-plus.svg
 * tags
 * - Banking 
 * - Shopping 
 */
export const InvoiceNewIcon = InvoicePlusIcon;
export default InvoiceNewIcon